import { normalizeOrigin } from "./appUrl";

/**
 * The host every link a person copies, scans or forwards points at.
 *
 * The app's public origin, baked in at build time by vite.config.ts from
 * APP_URL (or Vercel's VERCEL_PROJECT_PRODUCTION_URL) — see src/lib/appUrl.ts.
 * Never a literal here: the domain moves, and a hardcoded one would keep
 * minting links to the old host.
 *
 * Not `window.location.origin` when the build knows the app URL: that is
 * wherever the sharer happens to be — a Vercel preview, a *.vercel.app alias,
 * or localhost — so the same quest went out under different hosts and a link
 * shared from a preview was dead for whoever received it. Only a build with no
 * app URL at all (a local `vite` with nothing set) falls back to it.
 *
 * `VITE_SHARE_ORIGIN` overrides it, e.g. to point QR codes at a local server
 * while testing on a phone. A trailing slash is dropped so callers can append
 * a path that starts with `/`.
 */
export const APP_URL =
  normalizeOrigin(import.meta.env.VITE_APP_URL as string | undefined) ||
  (typeof window !== "undefined" ? window.location.origin : "");

export function resolveShareOrigin(override: string | undefined, appUrl: string = APP_URL): string {
  return normalizeOrigin(override) || appUrl;
}

export const SHARE_ORIGIN = resolveShareOrigin(import.meta.env.VITE_SHARE_ORIGIN as string | undefined);
